import { Box, Typography, IconButton, Collapse } from '@mui/material'
import GoogleIcon from '../../components/icon/GoogleIcon'
import { useState } from 'react'
import { SECTION_COLLAPSE_STYLES } from '../details/constants/ClientDashboardConst'
import { UI_COLOR_PRIMARY } from '../../constants/uiColors'

export default function SectionCollapse({
  title,
  icon,
  defaultOpen = true,
  children,
  type,
  ariaLabelOpen,
  ariaLabelClose,
  sx = {},
  headerSx = {},
  toggleSx = {}
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <Box
      className={type == 'secondary' ? 'section-non-elevated' : 'section-elevated'}
      sx={{
        mb: 2,
        ...sx
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          ...headerSx
        }}
        onClick={() => setOpen(!open)}
      >
        <Box display="flex" alignItems="center" gap={1}>
          {icon}
          <Typography
            fontWeight={SECTION_COLLAPSE_STYLES.titleWeight}
            color={
              type == 'title'
                ? SECTION_COLLAPSE_STYLES.titleColor
                : SECTION_COLLAPSE_STYLES.subtitleColor
            }
          >
            {title}
          </Typography>
        </Box>
        <IconButton
          size="small"
          aria-label={open ? ariaLabelClose : ariaLabelOpen}
          sx={{ color: UI_COLOR_PRIMARY, ...toggleSx }}
        >
          <GoogleIcon
            name={open ? 'expand_less' : 'expand_more'}
            size={SECTION_COLLAPSE_STYLES.toggleIconSize}
          />
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box px={2} pb={2}>
          {children}
        </Box>
      </Collapse>
    </Box>
  )
}
